import { Identification }   from "./identification.model";
import { Phone } from "./phone.model";
import { Address } from "./address.model";
import { OTA_Document } from "./ota_document.model";

export class RentingEntity {
    public renterId:        number;
    public title:           string = "";
    public firstName:       string = "";
    public principalName:   string = "";
    public identList = new Array<Identification>();  
    public phoneList = new Array<Phone>();
    public address:         Address;
    public dateofBirth?:     Date;
    public docList = new Array<OTA_Document>();
}
